import { tinaClient, useTina } from "@/utils";

import { Page, Header, Section, Markdown } from "@/components";

export default function Legal({ legalQuery, globalData }) {
  const { data } = useTina({
    ...legalQuery,
  });

  const { title, body, seo } = data.legal;

  return (
    <Page seo={seo} className="pb-24">
      <Header
        variant="short-centered"
        breadCrumb={["Legal"]}
        header={{
          title: title,
          subtitle: "The Eye Unit Private Clinic",
        }}
      />
      <Section className="!pt-12 pb-12">
        <Markdown content={body} />
      </Section>
    </Page>
  );
}

export const getStaticPaths = async () => {
  const { data } = await tinaClient.queries.legalConnection();
  const paths = data.legalConnection.edges.map((x) => {
    return { params: { slug: x.node._sys.filename } };
  });

  return {
    paths,
    fallback: "blocking",
  };
};

export const getStaticProps = async (ctx) => {
  try {
    const legalQuery = await tinaClient.queries.legal({
      relativePath: ctx.params.slug + ".mdx",
    });

    return {
      notFound: !legalQuery?.data?.legal,
      props: {
        legalQuery,
      },
    };
  } catch (error) {
    return {
      notFound: true,
      props: {},
    };
  }
};
